@if (klarnaIframeUrl !== '') {
    <iframe [src]="klarnaIframeUrl" width="100%" height="500px" frameborder="0"></iframe>
}
   
